export default __webpack_public_path__ + "./image/4aa1b74b58ae18e6b35a8bd1c5b20139.png";